import { useContext, useEffect, useState } from 'react';
import AuthContext from '../contexts/AuthContext';
import { AlertContext } from '../contexts/AlertContext';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { ArrowLeftSquare, ArrowRightSquare } from 'react-bootstrap-icons';
import ProductMetadataForm from '../components/ProductMetadataForm';
import ProductAndroidAssetForm from '../components/ProductAndroidAssetForm';
import ProductIosAssetForm from '../components/ProductIosAssetForm';
import ProductWebAssetForm from '../components/ProductWebAssetForm';
import internalStatuses from '../enumerations/internalProductStatuses';
import partnerStatuses from '../enumerations/partnerProductStatuses';
import collectionsSubcollections from '../enumerations/collectionsSubcollections';
import { Storage } from 'aws-amplify';

const PrevNextArrows = ({sku}) => {
  const history = useHistory();
  const { collection, productType } = useParams();
  // get the current sku list from localStorage
  let currentSKUList;
  let prevSKU;
  let nextSKU;
  try {
    currentSKUList = JSON.parse(window.localStorage.getItem('currentSKUList'));
  } catch (err) {
    console.error(err);
  }
  if (!currentSKUList || Array.isArray(currentSKUList) === false || currentSKUList.length === 0) {
    return null;
  }
  // get the previous and next SKUs
  const index = currentSKUList.indexOf(sku);
  if (index !== 0) { prevSKU = currentSKUList[index - 1]; }
  if ((index + 1) < currentSKUList.length) { nextSKU = currentSKUList[index + 1]; }
  return (
    <div className="pl-2">
      {prevSKU && (
        <ArrowLeftSquare
          className="pointer"
          onClick={() =>
            history.push(`/product/${collection}/${productType}/${prevSKU}`)
          }
        />
      )}{' '}
      {nextSKU && (
        <ArrowRightSquare
          className="pointer"
          onClick={() =>
            history.push(`/product/${collection}/${productType}/${nextSKU}`)
          }
        />
      )}
    </div>
  );
};

export const ProductPage = (params) => {
  const { authState } = useContext(AuthContext);
  const { dispatch } = useContext(AlertContext);
  const closeAlert = () => dispatch({ type: 'close' }); // HACK: needed to pass reducer dispatch() func
  const { collection, productType, productSKU } = useParams();
  const location = useLocation();
  const [productMetadata, setProductMetadata] = useState({});
  const [productStatus, setProductStatus] = useState('');
  const [productStatusSaving, setProductStatusSaving] = useState(false);
  const [productSubcollections, setProductSubcollections] = useState([
    'Subcollection...',
  ]);
  const [productSubcollectionSaving, setProductSubcollectionSaving] = useState(false);
  const [key, setKey] = useState('web');
  const statuses = (collection === 'facecake') ? internalStatuses : partnerStatuses;
  const subcollections = collectionsSubcollections[collection];

  useEffect(() => {
    console.log(collection);
    if (collection === 'ebay') return;
    // XXX: get the list of product images for this collection
    Storage.get(`p/${collection}/${productSKU}/metadata/index.json`, {
      download: true,
      cacheControl: 'no-cache',
    })
      .then((res) => {
        res.Body.text().then((resText) => {
          const productMetadata = JSON.parse(resText);
          setProductMetadata(productMetadata);
          setProductStatus(
            collection === 'facecake'
              ? productMetadata?.internalStatus || 'NEW'
              : productMetadata?.status || 'NEW'
          );
          setProductSubcollections(productMetadata?.subcollections);
        });
      })
      .catch((err) => console.warn(err));
  }, [location, collection, productType, productSKU]);

  // XXX: save JSON to S3
  const writeJSON = async (object, s3Path, onSuccess) => {
    try {
      //await Storage.remove(s3Path);
      const res = await Storage.put(s3Path, JSON.stringify(object, null, 2), {
        level: 'public',
        contentType: 'application/json',
        cacheControl: 'no-cache',
      });
      console.log('Product Web Config Updated:', res?.key);
      onSuccess();
    } catch (err) {
      console.warn('S3 write Error:', err);
      dispatch({
        type: 'success',
        title: 'Product Status NOT Saved',
        message: `ERROR: ${err}`,
        onConfirm: closeAlert,
      });
    }
  };

  const handleProductStatusChange = async (e) => {
    setProductStatusSaving(true);
    const productStatus = e.target.value;
    const statusType = collection === 'facecake' ? 'internalStatus' : 'status';
    writeJSON(
      { ...productMetadata, [statusType]: productStatus },
      `p/${collection}/${productSKU}/metadata/index.json`,
      () => setProductStatusSaving(false)
    );
    // HACK: also update product2.json if chanel
    if (['chanel'].includes(collection)) {
      const res = await Storage.get(`p/${collection}/products2.json`, {
        download: true,
        cacheControl: 'no-cache',
      });
      const resText = await res.Body.text();
      const products2 = JSON.parse(resText);
      const productIndex = products2?.[productType]?.products?.findIndex(product => {
        return product.sku === productSKU;
      });
      if (productIndex >= 0) {
        products2[productType].products.[productIndex].[statusType] = productStatus;
      }
      // update product metadata
      writeJSON(
        products2,
        `p/${collection}/products2.json`,
        () => null
      );
    }
    setProductStatus(productStatus);
  };

  const handleProductSubcollectionChange = async (e) => {
    setProductSubcollectionSaving(true);
    const productSubcollection = ['Subcollection...', '-- none --'].includes(
      e.target.value
    ) === false
      ? [e.target.value]
      : undefined;
    // update product metadata
    writeJSON(
      { ...productMetadata, subcollections: productSubcollection },
      `p/${collection}/${productSKU}/metadata/index.json`,
      () => setProductSubcollectionSaving(false)
    );
    // HACK: also update product2.json if chanel
    if (['chanel'].includes(collection)) {
      const res = await Storage.get(`p/${collection}/products2.json`, {
        download: true,
        cacheControl: 'no-cache',
      });
      const resText = await res.Body.text();
      const products2 = JSON.parse(resText);
      const productIndex = products2?.[productType]?.products?.findIndex(product => {
        return product.sku === productSKU;
      });
      if (productIndex >= 0) {
        products2[productType].products.[productIndex].subcollections = productSubcollection;

      }
      // update product metadata
      writeJSON(
        products2,
        `p/${collection}/products2.json`,
        () => null
      );
    }
    setProductSubcollections(productSubcollection);
  };

  const { name } = productMetadata;
  return (
    <Container fluid className="px-1 px-sm-1">
      <Row className="px-1 px-sm-3">
        <Col className="px-1 px-sm-3">
          <nav aria-label="breadcrumb">
            <div className="float-right py-1 pr-2 product-status-breadcrumb-fix">
              {
                subcollections?.length > 0 && (productSubcollectionSaving ? (
                  <div className="mt-2 mr-3 ">Saving...</div>
                ) : (
                  <Form
                    style={{ display: 'inline-block', paddingRight: '0.5rem' }}
                  >
                    <Form.Group controlId="productSubcollection">
                      <Form.Control
                        as="select"
                        custom
                        value={productSubcollections?.[0] || -1}
                        defaultValue={-1}
                        onChange={handleProductSubcollectionChange}
                      >
                        <option key="blankChoice" hidden value={-1}>
                          {' '}Subcollection...{' '}
                        </option>
                        {[' -- none -- ',...subcollections].map(
                          (subcollection) => (
                            <option
                              key={subcollection}
                              selected={productMetadata?.subcollections?.includes(
                                subcollection
                              )}
                            >
                              {subcollection}
                            </option>
                          )
                        )}
                      </Form.Control>
                    </Form.Group>
                  </Form>
                ))
              }
              {productStatusSaving ? (
                <div className="mt-2 mr-3 ">Saving...</div>
              ) : (
                <Form style={{ display: 'inline-block' }}>
                  <Form.Group controlId="productStatus">
                    <Form.Control
                      as="select"
                      custom
                      value={productStatus}
                      onChange={handleProductStatusChange}
                    >
                      {statuses.map((status) => (
                        <option key={status}>{status}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Form>
              )}
            </div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href={`/products/${collection}`}>
                  {collection?.toUpperCase()}
                </a>
              </li>
              <li className="breadcrumb-item" aria-current="page">
                <a href={`/products/${collection}/${productType}`}>
                  {productType?.toUpperCase()}
                </a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {name} ({productSKU.toUpperCase()})
                <PrevNextArrows sku={productSKU} />
              </li>
            </ol>
          </nav>
        </Col>
      </Row>
      <Row className="px-1 px-sm-3">
        <Col className="px-1 px-sm-3">
          <Tabs
            id="product-metadata-tabs"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab
              eventKey="metadata"
              title={
                <span>
                  <span className="d-none d-sm-inline">Product</span> Metadata
                </span>
              }
            >
              <br />
              <ProductMetadataForm
                collection={collection}
                productSKU={productSKU}
              />
            </Tab>
            <Tab
              eventKey="web"
              title={
                <span>
                  Web <span className="d-none d-sm-inline">Asset</span>
                </span>
              }
            >
              <br />
              <ProductWebAssetForm
                collection={collection}
                productSKU={productSKU}
                productImages={productMetadata?.images}
                isActive={key === 'web'}
              />
            </Tab>
            {authState?.userGroups?.includes('facecake/admin') && (
              <Tab
                eventKey="ios"
                title={
                  <span>
                    iOS <span className="d-none d-sm-inline">Asset</span>
                  </span>
                }
              >
                <br />
                <ProductIosAssetForm
                  collection={collection}
                  productSKU={productSKU}
                  productImages={productMetadata?.images}
                  isActive={key === 'ios'}
                />
              </Tab>
            )}
            {authState?.userGroups?.includes('facecake/admin') && (
              <Tab
                eventKey="android"
                title={
                  <span>
                    Android <span className="d-none d-sm-inline">Asset</span>
                  </span>
                }
              >
                <br />
                <ProductAndroidAssetForm
                  collection={collection}
                  productSKU={productSKU}
                  productImages={productMetadata?.images}
                  isActive={key === 'android'}
                />
              </Tab>
            )}
          </Tabs>
        </Col>
      </Row>
    </Container>
  );
};
